import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

export const SuccessDialog: React.FC<{}> = () => {
  const { t } = useTranslation()

  return (
    <>
      <div css={backgroundStyle}></div>
      <div css={dialogStyle}>
        <div className="content-block">
          <img src={require('@/static/images/self-checkin-payment/terminal/icon_check.svg')} />
          <div className="-text">{t('Payment has been completed')}</div>
        </div>
      </div>
    </>
  )
}

const backgroundStyle = css({
  background: 'rgba(0, 0, 0, 0.5)',
  height: '100vh',
  width: '100vw',
  position: 'fixed',
  zIndex: 1000,
  top: 0,
  left: 0,
})
const dialogStyle = css(
  {
    position: 'fixed',
    zIndex: 1001,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 440,
    minHeight: 242,
    background: '#FFFFFF',
    borderRadius: 10,
    '.content-block': {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      gap: 24,
      width: '100%',
      height: '100%',
      padding: 40,
      img: { width: 100, height: 100 },
    },
    '.-text': {
      fontSize: 28,
      lineHeight: '38px',
      fontWeight: 'bold',
      letterSpacing: 1.4,
      color: '#272727',
      textAlign: 'center',
    },
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { minHeight: 248, '.-text': { fontSize: 32, lineHeight: '44px', letterSpacing: 1.6 } },
  }),
)
